<template>
  <div class="screen">
    <div class="screen screen-loading" v-if="!iframeVisible">
      <SignatureLoadingScreenVue :hideBackButton="true" />
    </div>
    <div :class="{
      'docusign-area': true,
      'docusign-area__visible': iframeVisible,
    }" id="docusign" />
  </div>
</template>

<style lang="scss" scoped>
  .docusign-area {
    width: 100%;
    height: 1px;

    &__visible {
      height: calc(100vh - 100px);
    }

    &:empty {
      height: 0;
    }
  }
  .screen {
    width: 100%;
  }

  .docusign-area:not(:empty) ~ .screen-loading {
    display: none;
  }
</style>

<script>
import { mapActions, mapState } from 'vuex';
import SignatureLoadingScreenVue from './SignatureLoadingScreen.view.vue';

export default {
  name: 'SignatureScreen',
  components: {
    SignatureLoadingScreenVue
  },
  data() {
    return {
      urlToLoad: '',
      showLoading: true,
      unitsAllowed: [716, 846],
      clientsIdAllowed: [67, 63],
      iframeVisible: false
    };
  },
  async mounted() {
    const unitId = Number(this.currentAdmission.unitId);
    const payments = Number(this.currentAdmission.payments[0].clientId);
    window.addEventListener('beforeunload', this.beforeUnloadHandler);

    const elegibleToSignExams =
    this.unitsAllowed.includes(unitId) && this.clientsIdAllowed.includes(payments);

    if (elegibleToSignExams) {
      await this.handleStart();
      window.addEventListener('message', this.receiveMessage);
    } else {
      return this.notElegibleToSignature();
    }
  },
  beforeDestroy() {
    window.removeEventListener('message', this.receiveMessage);
    window.removeEventListener('beforeunload', this.beforeUnloadHandler);
  },
  computed: {
    ...mapState({
      currentAdmission: ({ currentAdmission }) => currentAdmission.data,
    }),
  },
  methods: {
    ...mapActions(['getDocuSignUrl']),
    async handleStart() {
      try {
        this.createDocuSignScript();

        let originUrl = 'https://atendimento.dasa.com.br';

        if (process.env.currentEnv !== 'prd') {
          originUrl = 'http://unit-front-admission.azr-hml02.dasaexp.io';
        }

        const { url } = await this.getDocuSignUrl({
          redirectUrl: `${originUrl}${process.env.BASE_URL}confirmacao-assinatura-digital`,
        });
        this.urlToLoad = url;
        setTimeout(() => {
          this.loadDocusignData();
        }, 300);
      } catch (err) {
        this.failSignature();
      }
    },
    createDocuSignScript() {
      const isProd = process.env.currentEnv === 'prd';
      const wrappedUrl = isProd ? 'https://js.docusign.com/bundle.js' : 'https://js-d.docusign.com/bundle.js';

      const docuSignScript = document.createElement('script');
      docuSignScript.setAttribute('src', wrappedUrl);
      document.head.appendChild(docuSignScript);
    },
    signatureSucced() {
      return this.goNextStep('admission_done');
    },
    receiveMessage(event) {
      if (event.data === 'SUCCESS_SIGNATURE') {
        return this.signatureSucced();
      }
    },
    failSignature() {
      return this.goNextStep('admission_done');
    },
    notElegibleToSignature() {
      return this.goNextStep('admission_done');
    },
    loadDocusignData() {
      window.DocuSign.loadDocuSign(process.env.vueAppDocusignKey)
        .then((docusign) => {
          const customSigning = {
            url: this.urlToLoad,
            displayFormat: 'focused',
            style: {
              branding: {
                primaryButton: {
                  backgroundColor: '#0037ff',
                  color: '#fff',
                },
              },
              signingNavigationButton: {
                finishText: 'Continuar',
                position: 'bottom-center',
              },
            },
          };

          const signing = docusign.signing(customSigning);

          /** Event handlers **/
          signing.on('ready', (event) => {
            this.iframeVisible = true;
          });

          signing.on('sessionEnd', (event) => {
            return this.signatureSucced();
          });

          signing.mount('#docusign');
        })
        .catch((ex) => {
          console.error('=====');
          console.error(`Error to open DocuSign to admissionId ${this.currentAdmission.id} | Unit ${this.currentAdmission.unitId}`);
          console.error('Probably error: ', ex);
          console.error('=====');
        });
    },
    beforeUnloadHandler(event) {
      event.preventDefault();
    },
  },
};
</script>
